export default __webpack_public_path__ + "static/media/postgresql.84b01692.png";